import { render, staticRenderFns } from "./moto.vue?vue&type=template&id=16619256&scoped=true"
import script from "./moto.vue?vue&type=script&lang=js"
export * from "./moto.vue?vue&type=script&lang=js"
import style0 from "./moto.vue?vue&type=style&index=0&id=16619256&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16619256",
  null
  
)

export default component.exports